import {styled} from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export const AgyleTabs = styled((props) => <Tabs TabIndicatorProps={{style: {transition: 'none'}}} {...props} />)(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.paperDarker,
  height: 40,
  minHeight: 41,
  padding : "0 2px",

  "& .MuiButtonBase-root": {
    height: 40,
    minHeight: 40
  },
  "& .Mui-disabled": {
    display: 'none'
  },
  "& .MuiTabScrollButton-root": {
    boxShadow: `0 4px 0px -1.5px #686868`
  },
  '& .MuiTabs-indicator': {
    backgroundColor: '#1890ff',
    position: 'absolute',
    top: 0,
    transform: "scale(95%)",
  },
  '.MuiTabs-flexContainer': {
    borderBottom: `2px solid #686868`,
    width: '100%',
    minWidth: 'max-content',
  },
}));

export const AgyleTab = styled((props) => <Tab {...props} />)(({ theme }) => ({
  textTransform: 'none',
  color: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.85)' : '#9E9E9E',
  borderTopLeftRadius: 5,
  borderTopRightRadius: 5,
  borderLeft: '2px solid transparent',
  borderRight: '2px solid transparent',
  fontWeight: 'normal',
  minWidth: 125,
  '&:hover': {
    color: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.85)' : '#9E9E9E',
    opacity: 1,
    backgroundColor: theme.palette.background.paper,
  },
  '&.Mui-selected': {
    color: theme.palette.mode === 'light' ? "black": 'white',
    backgroundColor: theme.palette.mode === 'light' ? '#FFFFFF' : '#222425',
    fontWeight: 'bold',
    borderLeftColor: '#686868',
    borderRightColor: '#686868',
    boxShadow: `0 4px 0px -1.5px ${theme.palette.background.default}`
  },
}));
